// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-_EtP","input":"input-fOnE"};